import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { getFormatDate } from "~/libs/getFormatDate";
import { BASE_TARIFFS_OPTIONS } from "~/pages/Directory/BaseTariffs/options";
import { applySortToColumns } from "~/shared/ui/TableV2";

const formatPrice = (value: string) => {
  const parsed = Number(value);
  return Number.isNaN(parsed) ? value : String(parsed);
};

export const getBaseTariffsColumns = (
  t: TFunction,
  sortField?: string,
  sortType?: string,
  sortableColumns?: string[],
): ColumnsType<any> => {
  const columns = BASE_TARIFFS_OPTIONS.map((option) => {
    const baseColumn = {
      title: t(`directory.baseTariffs.table.${option}`),
      dataIndex: option,
      key: option,
    };

    if (option === "createdAt" || option === "updatedAt") {
      return {
        ...baseColumn,
        render: (value: string) => (
          <span>{value ? getFormatDate(value) : "—"}</span>
        ),
      };
    }

    if (option === "price") {
      return {
        ...baseColumn,
        render: (value: string) => (
          <span>{value ? formatPrice(value) : "—"}</span>
        ),
      };
    }

    if (option === "position") {
      return {
        ...baseColumn,
        render: (_value: string, record: { positions?: string[] }) => {
          const positions = record.positions ?? [];

          if (!positions.length) return <span>—</span>;

          return (
            <div>
              {positions.map((position, index) => (
                <div key={position}>
                  {position}
                  {index < positions.length - 1 ? "," : ""}
                </div>
              ))}
            </div>
          );
        },
      };
    }

    return {
      ...baseColumn,
      render: (value: string) => <span>{value || "—"}</span>,
    };
  });

  return applySortToColumns(columns, sortField, sortType, sortableColumns);
};
